import bb from 'blingblingjs';


let state = {
	openlinks : new Set
}


// Dom elements
const links = bb('.js-el__footer-nav-links');
const toggleHandle = bb('.js-fn__toggle-footer-nav-links');



// Click handlers
toggleHandle.on('click', e => {
	const heading = e.currentTarget.dataset.heading;
	state.openlinks.has(heading) ? state.openlinks.delete(heading) : state.openlinks.add(heading);
	update()
})



function update(){
	links.forEach(el => {
		el.classList.toggle('--is-open', state.openlinks.has(el.dataset.heading))
	})
}




